export default __webpack_public_path__ + "static/media/venori-logotype.e3833b52.webp";